import "./portfolio.scss";
import PortfolioList from "../portfolioList/PortfolioList";
import { useState, useRef } from "react";
import {dataProject} from "../../data/dataProject";
import Button from "../button/Button";
import Modal from '@mui/material/Modal';
import {Box} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Autoplay from 'embla-carousel-autoplay';
import EmblaCarousel from "../Carousel/EmblaCarousel";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "90%",
    bgcolor: '#06044A',
    borderRadius: "10px",
    boxShadow: 24,
};

export default function Portfolio(){
    const [selected, setSelected] = useState("all");
    const [open, setOpen] = useState(false);
    const [projectSelected, setProjectSelected] = useState(null);
    const handleClose = () => setOpen(false);

    const options = {};

    const list = [
        {
            id: "web",
            title: "Web App"
        },
        {
            id: "java",
            title: "App Java"
        },
        {
            id: "design",
            title: "Web design"
        },
        {
            id: "all",
            title: "All"
        }
    ]

    function clickDetailsProject(value){
        setOpen(true);
        setProjectSelected(value);
    }

    return (
        <div className="portfolio" id={"portfolio"}>
            <h1 className={"title"}>Mes projets</h1>
            <span className={"divider"}/>
            <ul className={"list-portfolio"}>
                {list.map(item=>(
                    <PortfolioList title={item.title} active={selected === item.id} setSelected={setSelected} id={item.id}/>
                ))}
            </ul>
            <div className={"container"}>
                {dataProject.filter((valueFilter)=> valueFilter.tagSelected.includes(selected)
                ).map((value)=>
                    <div className={"item"}>
                        <img src={value.image} className={"image-portfolio"} alt={""}/>
                        <div className={"portfolio-box"}>
                            <Button title={"Voir le projet"} className={"btn-project-details"} onClick={()=>clickDetailsProject(value)}/>
                            <h2 className={"title"}>{value.title}</h2>
                            <p>{value.description}</p>
                        </div>
                        <div className={"list-tag"}>
                            {value.tags.map((tag, numb) =>
                                <span className={"tag"}>
                                    {tag?.icon}{tag.title}
                                </span>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                style={{background: "color(0,0,0,0.5)"}}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Box sx={style} className={"modal-portfolio"}>
                    <div className={"header-portfolio"} style={{backgroundColor: projectSelected?.detailsProjects?.color}}>
                        <h2 id="transition-modal-title" className={"title-portfolio"} variant="h6" component="h2">
                            {"Projet - "+ projectSelected?.title}
                        </h2>
                        <Button icon={<CloseIcon />} className={"btn-project-portfolio"} onClick={handleClose}/>
                    </div>

                    <div className={"container-portfolio"}>
                        <div className={"first-category"}>
                            <div className={"first-container"}>
                                <h3 className={"subtitle-portfolio"}>Contexte :</h3>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]}>{projectSelected?.detailsProjects?.context}</ReactMarkdown>
                            </div>

                            <div className={"first-container"}>
                                <h3 className={"subtitle-portfolio"}>Technologies utilisées :</h3>
                                <div className={"container-tags"}>
                                    {projectSelected?.detailsProjects?.technologieUsed.map((value)=> {
                                            return (
                                                value?.link ? <a className={"tag"} href={value.link} target={"_blank"}>
                                                    {value?.icon}{value.title}
                                                </a> : <span className={"tag"}>
                                                    {value?.icon}{value.title}
                                                </span>
                                            )
                                        }
                                    )}
                                </div>
                            </div>

                            {projectSelected?.detailsProjects?.description && <div className={"first-container"}>
                                <h3 className={"subtitle-portfolio"}>Description :</h3>
                                <ReactMarkdown rehypePlugins={[rehypeRaw]}>{projectSelected?.detailsProjects?.description}</ReactMarkdown>
                            </div>}

                            {projectSelected?.detailsProjects?.links ? <div className={"first-container"} >
                                <h3 className={"subtitle-portfolio"}>Liens externes :</h3>
                                <div className={"container-tags"}>
                                    {projectSelected?.detailsProjects?.links.map((value)=>
                                        <a className={"tag"} href={value.src} target="_blank">
                                                {value?.icon}{value.title}
                                            </a>
                                    )}
                                </div>
                            </div> : ""}
                        </div>
                        <div className={"second-category"}>
                            <EmblaCarousel slides={projectSelected?.detailsProjects?.carousel} options={options}/>
                        </div>
                    </div>

                </Box>
            </Modal>

        </div>
    )
}